import {onresizeend} from '../utils/onResizeEndFunctionCall';
import {getPercentOfView} from '../utils/getPercentOfView';

const mainHeader = document.querySelector('.c-main-header');
const rootStyles = document.querySelector(':root').style;
const home = document.querySelector('.s-home');

const setCSSProperties = () => {
    rootStyles.setProperty('--header-height', `${mainHeader.offsetHeight}px`);
};

setCSSProperties();
onresizeend(setCSSProperties);

const observeHeaderHeight = new ResizeObserver(() => {
    setCSSProperties();
});

observeHeaderHeight.observe(mainHeader);
